import React, { createContext, useContext, useState } from "react";
import en from "../../../assets/config/translations/gb.json";
import no from "../../../assets/config/translations/no.json";
import sv from "../../../assets/config/translations/se.json";
import da from "../../../assets/config/translations/dk.json";
import fi from "../../../assets/config/translations/fi.json";

const translations = { en, sv, no, da, fi };

const TranslationProvider = createContext();

export const TranslationsProvider = ({ children, language}) => {
  const [translation, setTranslation] = useState(language || "en");
  const t = (key) => {
    const parts = key.split(".");
    let result = translations[translation];
    for (let part of parts) {
      if (!result || !result[part]) return key;
      result = result[part];
    }
    return result;
  };

  return (
    <TranslationProvider.Provider value={{ t, translation, setTranslation }}>
      {children}
    </TranslationProvider.Provider>
  );
}; 

export const useTranslation = () => useContext(TranslationProvider);
